/**
 * @see https://umijs.org/docs/max/access#access
 */
export default function access(
    initialState: { currentUser?: API.CurrentUser } | undefined,
) {
    const { currentUser } = initialState ?? {};
    const isAdmin = currentUser?.Role === 1;
    const perms = new Set(currentUser?.Permissions ?? []);
    // 超管拥有全部菜单权限；成员按其角色 permissions 判断
    const has = (key: string) => isAdmin || perms.has(key);

    return {
        canAdmin: isAdmin,
        isAdmin,
        canTenant: has('tenant'),
        canOrg: has('org') || has('org:structure') || has('org:member'),
        canOrgStructure: has('org:structure'),
        canOrgMember: has('org:member'),
        canRole: has('role'),
        canGrant: has('grant'),
        canAudit: has('audit'),
        canDeploy: has('deploy'),
    };
}
